module.exports = __webpack_public_path__ + "static/img/banner-1.ddbb923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/banner-1.png
// module id = G6qe
// module chunks = 10